import { yup } from '../yup';

export const schema = yup.object().shape({
  owners: yup
    .array(
      yup.object().shape({
        _requestNumberConfirmation: yup.boolean().required(),
        _requestIdentityConfirmation: yup.boolean().required(),
        ownerId: yup.string().required(),
        myNumber: yup
          .string()
          .required('マイナンバーは必須です')
          .matches(/^\d{12}$/, 'マイナンバーは12桁の半角数字で入力してください'),
        myNumberImage: yup.mixed<File>().when('_requestNumberConfirmation', {
          is: true,
          then: (schema) => schema.required('番号確認書類は必須です'),
        }),
        idImage0: yup
          .mixed<File>()
          .fileSize()
          .when('_requestIdentityConfirmation', {
            is: true,
            then: (schema) => schema.required('身元確認書類は必須です'),
          }),
        idImage1: yup.mixed<File>().fileSize(),
      }),
    )
    .required(),
});

export type Schema = yup.InferType<typeof schema>;
